import { Component, forwardRef, inject } from '@angular/core';
import { NG_VALUE_ACCESSOR, NG_VALIDATORS, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DomSanitizer } from '@angular/platform-browser';
import { MatFormField, MatLabel, MatInput, MatHint, MatError } from '@angular/material/input';
import { NgxMaskDirective } from 'ngx-mask';
import { E2eIdDirective } from '@lc/ui/lib/core';
import { Masks } from '../input-masks';
import { TextboxComponent } from '../textbox/textbox.component';

@Component({
  selector: 'lc-phone-number',
  templateUrl: './phone-number.component.html',
  styleUrls: ['./phone-number.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => PhoneNumberComponent),
      multi: true,
    },
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => PhoneNumberComponent),
      multi: true,
    },
  ],
  imports: [
    MatFormField,
    MatLabel,
    MatInput,
    FormsModule,
    NgxMaskDirective,
    ReactiveFormsModule,
    MatHint,
    MatError,
    E2eIdDirective,
  ],
})
export class PhoneNumberComponent extends TextboxComponent {
  constructor() {
    super();
    this.inputMask = Masks.phoneNumber;
    this.placeholder = '000.000.0000';
  }
}
